<template>
    <div :class="['betslip', { open: isToggle }]">
        <div class="betslip__header" @click="onToggleBetslip()">
            <div class="betslip__header-info">
                <h3 class="betslip__header-title">{{ getTranslatedText('betslip') }}</h3>
                <div class="betslip__header-quantity">
                    <span class="betslip__header-quantity-text">
                        {{ $store.state.betslip.length }}
                    </span>
                </div>
            </div>
            <div class="betslip__header-action">
                <button
                    v-show="$store.state.betslip.length > 0"
                    class="betslip__header-close"
                    @click.stop="onConfirmClearAll"
                >
                    {{ getTranslatedText('clear all') }}
                </button>
                <div class="betslip__toggle">
                    <img src="~ThemePath/img/drop-down.png" />
                </div>
            </div>
        </div>
        <div class="betslip-content">
            <div class="betslip-content-list" :class="{ 'no-mr': $store.state.betslip.length === 0 }">
                <span class="betslip-empty" v-show="$store.state.betslip.length === 0">
                    {{ getTranslatedText('empty') }}
                </span>
                <div class="betslip-content-item" v-for="(item, index) in $store.state.betslip" :key="index">
                    <div class="betslip-content-item-info">
                        <img class="betslip-content-item-icon" :src="addTimestampToURL(item.icon)" :alt="item.number" />
                        <div class="betslip-content-item-info-item">
                            <span class="betslip-content-item-info-name">
                                {{
                                    getTranslatedText(
                                        'nr [name]',
                                        {
                                            name: item.name,
                                        },
                                        false
                                    )
                                }}
                            </span>
                            <span class="betslip-content-item-info-price">
                                {{ getTranslatedText('possible win') }}
                                <span class="currency">
                                    <b v-html="$store.state.accountSetting.currency.symbol"></b>
                                    {{ formatMoney(item.win) }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="betslip-content-item-right">
                        <div class="betslip-content-item-action">
                            <span class="currency" v-html="$store.state.accountSetting.currency.symbol"></span>
                            <input
                                :value="item.price"
                                type="number"
                                class="betslip-content-item-action-input-field"
                                pattern="[0-9]+([\.,][0-9]+)?"
                                step="0.01"
                                @change="(e) => onChangePrice(e, index)"
                                @focus="idShowDropDown = -1"
                                @blur="(e) => onBlurPrice(e, index)"
                            />
                            <div class="betslip-content-item-action-dropdow" @click="onShowStakeAmount(index)">
                                <img src="~ThemePath/img/drop-down.png" />
                            </div>
                            <div class="betslip-content-stake-amount" :class="{ show: index === idShowDropDown }">
                                <span
                                    class="betslip-content-stake-amount-item"
                                    v-for="(v, i) in $store.state.stakePrice"
                                    :key="i"
                                    @click="onSelectStake(v)"
                                    >{{ v }}</span
                                >
                            </div>
                        </div>
                        <img
                            class="betslip-content-item-close"
                            src="~ThemePath/img/close.png"
                            @click="onRemoveItem(item.number)"
                        />
                    </div>
                </div>
            </div>
            <template v-if="$store.state.betslip.length > 0">
                <template v-if="$store.state.isLogin">
                    <button
                        class="betslip__button-place-bet"
                        @click="onSubmitBet({ isDemo: false })"
                        :disabled="isLoadingButton"
                    >
                        <LoadingButton v-if="isLoadingButton" />
                        <template v-else>
                            {{ getTranslatedText('place bet') }}
                        </template>
                    </button>
                </template>
                <template v-else>
                    <div class="betslip__button-box">
                        <button class="betslip__button-place-bet" @click="onLogin()" :disabled="isLoadingButton">
                            <LoadingButton v-if="isLoadingButton" />
                            <template v-else>
                                {{ getTranslatedText('Login') }}
                            </template>
                        </button>
                        <button
                            v-if="$store.state.accountSetting.show_demo_version"
                            class="betslip__button-place-demo"
                            @click="onSubmitBet({ isDemo: true })"
                            :disabled="isLoadingButton"
                        >
                            <LoadingButton v-if="isLoadingButton" />
                            <template v-else>
                                {{ getTranslatedText('Play demo') }}
                            </template>
                        </button>
                    </div>
                </template>
            </template>
        </div>
        <Notification ref="notificationRef"></Notification>
        <ResultBeslip ref="resultBeslipRef" :listNumber="listNumber" @on-close-betslip="isToggle = false" />
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import VersionCache from '@/mixins/version-cache/version-cache-mixins'

import EventBus from '@/utils/EventBus'
import LoadingButton from '@/components/common/loading-button.vue'
import Notification from '@/components/common/notifi.vue'
import ResultBeslip from '@/components/betslip/result.vue'

import { formatPrice, isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins, themeMixins, VersionCache],
    components: { LoadingButton, Notification, ResultBeslip },
    props: {
        listNumber: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            idShowDropDown: -1,
            isLoadingButton: false,
            currency: '&#82;',
            isToggle: false,
        }
    },
    computed: {
        betslip() {
            return this.$store.state.betslip
        },
    },
    watch: {
        betslip: {
            handler(newValue) {
                if (newValue.length === 1) {
                    this.isToggle = true
                }
            },
            deep: true,
        },
    },
    created() {
        EventBus.$on('on-confirm', () => this.onClearAll())
    },
    destroyed() {
        EventBus.$off('on-confirm')
    },
    methods: {
        onLogin() {
            window.parent.postMessage({ command: 'login' }, '*')
        },

        onSubmitBet({ isDemo }) {
            this.$refs.resultBeslipRef.openResult({ isDemo })
            this.idShowDropDown = -1
        },

        onConfirmClearAll() {
            this.idShowDropDown = -1
            EventBus.$emit('on-show-confirm')
        },

        onClearAll() {
            this.$store.dispatch('onClearbetslip')
        },

        onRemoveItem(number) {
            const payload = {
                number,
            }
            this.idShowDropDown = -1
            this.$store.dispatch('removeTobetslip', payload)
        },

        onShowStakeAmount(index) {
            let idShow = index
            if (index === this.idShowDropDown) {
                idShow = -1
            }
            this.idShowDropDown = idShow
        },

        onBlurPrice(e, index) {
            if (isStrEmpty(e.target.value)) {
                let payload = {
                    price: 1,
                    index: index,
                }
                this.$store.dispatch('updatePriceBetslip', payload)
            }
        },

        onChangePrice(e, index) {
            let payload = {
                price: e.target.value,
                index: index,
            }
            this.$store.dispatch('updatePriceBetslip', payload)
        },

        onSelectStake(stake) {
            let payload = {
                stake,
                index: this.idShowDropDown,
            }
            this.$store.dispatch('updateWinBetslip', payload)
            this.idShowDropDown = -1
        },

        onToggleBetslip() {
            this.isToggle = !this.isToggle
        },

        formatMoney(price) {
            return formatPrice(parseFloat(price))
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/betslip/index.scss';
</style>
